(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const id = url.hash.slice(1);
        let card = document.getElementById(id);
        if (!card && window.matchMedia('(max-width: 749px)').matches) {
          card = document.getElementById(id + '-mobile');
        }
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function setCollectionContentCardMinHeight() {
    const SAMPLE_SIZE = 5;
    const RESIZE_DEBOUNCE_MS = 150;

    function sampleMinHeight(container) {
      if (!container) return 0;
      const items = container.querySelectorAll('.product-grid__item:not([data-content-card])');
      const heights = Array.from(items)
        .slice(0, SAMPLE_SIZE)
        .map((el) => el.offsetHeight)
        .filter((h) => h > 0);
      return heights.length ? Math.min(...heights) : 0;
    }

    function updateMinHeight() {
      const section = document.getElementById('ResultsList')?.closest('.js-main-collection');
      if (!section) return;

      const desktopGrid = section.querySelector('.product-grid.collection-content-grid--desktop');
      const tabletGrid = section.querySelector('.product-grid.collection-content-grid--tablet');
      const mobileGrid = section.querySelector('.product-grid.collection-content-grid--mobile');
      const desktopMin = sampleMinHeight(desktopGrid);
      const tabletMin = sampleMinHeight(tabletGrid);
      const mobileMin = sampleMinHeight(mobileGrid);

      section.style.setProperty(
        '--collection-content-card-min-height-desktop',
        `${desktopMin || tabletMin || mobileMin}px`
      );
      section.style.setProperty(
        '--collection-content-card-min-height-mobile',
        `${mobileMin || tabletMin || desktopMin}px`
      );
    }

    let debounceTimeout;
    function debouncedUpdateMinHeight() {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(updateMinHeight, RESIZE_DEBOUNCE_MS);
    }

    if (document.readyState === 'complete') {
      updateMinHeight();
    } else {
      window.addEventListener('load', updateMinHeight, { once: true });
    }
    window.addEventListener('resize', debouncedUpdateMinHeight);
    document.addEventListener('filter:update', debouncedUpdateMinHeight);
  })();

  } catch(e) { console.error(e); }
})();
})();
